 (function () {
          document.addEventListener('DOMContentLoaded', function () {
            document.body.addEventListener('change', function (e) {
              if (e.target && e.target.classList.contains('rc-selling-plans__dropdown')) {
                // 1. Get the current Variant ID from your hidden input
                const currentVariantId = document.querySelector('input[name="id"]').value;
                const labelNearSelectedOption = document.querySelector(
                  `.variant-picker__option-values .option_wrapper label[data-variant-id="${currentVariantId}"]`
                );
                const selectedVariantRadio = labelNearSelectedOption
                  .closest('.option_wrapper')
                  .querySelector('input[type="radio"]');
                console.log('selectedVariantRadio', selectedVariantRadio);
                // Force select variant
                selectedVariantRadio.checked = true;
                selectedVariantRadio.dispatchEvent(new Event('change', { bubbles: true }));
              }
            });
            const MAX_TRIES = 40;
            let tries = 0;
            let resolved = false;

            function log(...args) {
              console.info('[subfix]', ...args);
            }

            function getOneTimeInput() {
              return (
                document.querySelector('.rc-option__onetime .rc-radio__input') ||
                document.querySelector('input.rc_widget__option__input--onetime')
              );
            }

            function getSubscribeInput() {
              return (
                document.querySelector('.rc-option__subsave .rc-radio__input') ||
                document.querySelector('input.rc_widget__option__input--subsave')
              );
            }

            function setActiveClasses() {
              document
                .querySelector('.rc-option__subsave')
                ?.classList.remove('rc-option--active', 'rc_widget__option--active');

              document
                .querySelector('.rc-option__onetime')
                ?.classList.add('rc-option--active', 'rc_widget__option--active');
            }

            function triggerEvents(el) {
              const label = document.querySelector(`label[for="${el.id}"]`);
              if (label) label.click();

              el.click();
              el.checked = true;

              ['input', 'change', 'click'].forEach((evt) => el.dispatchEvent(new Event(evt, { bubbles: true })));

              el.setAttribute('aria-checked', 'true');
            }

            function tryActivate() {
              if (resolved) return true;
              tries++;

              const input = getOneTimeInput();
              if (!input) {
                log('One-time input not available yet (try ' + tries + ')');
                return false;
              }

              log('Found one-time input', input);

              // Turn off subscription if selected
              const subsave = getSubscribeInput();
              if (subsave && subsave.checked) {
                subsave.checked = false;
                subsave.dispatchEvent(new Event('change', { bubbles: true }));
              }

              triggerEvents(input);
              setActiveClasses();

              setTimeout(() => {
                if (input.checked) {
                  resolved = true;
                  log('✔ Activated One-time successfully');
                }
              }, 500);

              return resolved;
            }

            // MutationObserver: reacts when Recharge injects widget
            const observer = new MutationObserver(() => {
              if (resolved) return observer.disconnect();
              if (tryActivate()) {
                log('Activated via MutationObserver');
                observer.disconnect();
              }
            });

            observer.observe(document.body, { childList: true, subtree: true });

            // Polling fallback
            const interval = setInterval(() => {
              if (resolved || tries >= MAX_TRIES) {
                clearInterval(interval);
                observer.disconnect();
                return;
              }

              if (tryActivate()) {
                log('Activated via interval');
                clearInterval(interval);
                observer.disconnect();
              }
            }, 10000);
          });
        })();